import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import $ from "jquery";
import { minDate } from "../../Constants/Constants";

const UpdatePrivateLocalOrderDetail = ({ getData, rowId, setRowId }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");

  const [company, setCompany] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [product, setProduct] = useState([]);
  const [storeProduct, setStoreProduct] = useState([]);
  const [apiHit, setApiHit] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({
    product_id: "",
    product_name: "",
  });
  const [singlePrivateLocalOrder, setSinglePrivateLocalOrder] = useState([
    {
      rate: 0,
      date: "",
      received_date: "",
      status: "",
      total_order_qty: "",
      gst_percent: "",
      remarks: "",
      party_name: "",
      product_name_id: "",
    },
  ]);
  const [party, setParty] = useState([]);
  const [privateRate, setPrivateRate] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "product") {
      if (value) {
        const selectedProductValue = JSON.parse(value);
        const { product_id, product_name } = selectedProductValue;
        console.log(product_id);
        setSelectedProduct({ product_id, product_name });
        setSinglePrivateLocalOrder(() => ({
          ...singlePrivateLocalOrder,
          product_name: product_name,
          product_name_id: product_id,
        }));
      } else {
        setSelectedProduct({ product_id: "", product_name: "" });
      }
    } else {
      // For other inputs, update state as usual
      setSinglePrivateLocalOrder((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  const getProductDetails = async (e) => {
    const BASE_URL = SERVER_URL + `/api/product/drop-products/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: singlePrivateLocalOrder.company_id,
      }),
    });
    const result = await res.json();
    // console.log(result.data)
    if (res.ok) {
      setProduct(result.data);
    } else {
      setProduct([]);
    }
  };

  useEffect(() => {
    if (singlePrivateLocalOrder.company_id) {
      getProductDetails();
    }
  }, [singlePrivateLocalOrder.company_id]);

  const handleSinglePrivateLocalOrder = async () => {
    const BASE_URL =
      SERVER_URL +
      `/api/private-local/single-local-order-details/${user_id}/${rowId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setSinglePrivateLocalOrder(result.data);
      setApiHit(true);
    } else {
      setSinglePrivateLocalOrder({});
    }
  };

  const getParty = async () => {
    const BASE_URL =
      SERVER_URL + `/api/private-rate/all-private-rate/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setParty(result.data);
    } else {
      setParty([]);
    }
  };

  const getPrivateRate = async () => {
    const BASE_URL = `${SERVER_URL}/api/private-rate/drop-private-rate/${user_id}?party_name=${singlePrivateLocalOrder.party_name}&product_name=${singlePrivateLocalOrder.product_name}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setPrivateRate(result.data);
    } else {
      setPrivateRate(null);
    }
  };

  useEffect(() => {
    getCompany();
    getParty();
  }, []);

  useEffect(() => {
    if (rowId) {
      handleSinglePrivateLocalOrder();
    }
  }, [rowId]);

  useEffect(() => {
    if (apiHit) {
      setSelectedProduct({
        product_id: singlePrivateLocalOrder?.product_name_id,
        product_name: singlePrivateLocalOrder?.productName?.size,
      });
    }
  }, [apiHit]);

  useEffect(() => {
    if (
      singlePrivateLocalOrder.party_name &&
      singlePrivateLocalOrder.product_name
    ) {
      getPrivateRate();
    }
  }, [
    singlePrivateLocalOrder.party_name,
    singlePrivateLocalOrder.product_name,
  ]);

  useEffect(() => {
    setSinglePrivateLocalOrder((prevData) => ({
      ...prevData,
      rate: privateRate ? privateRate.private_rate : 0,
    }));
  }, [privateRate]);

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      id,
      party_name,
      date,
      remarks,
      rate,
      gst_percent,
      received_date,
      total_order_qty,
      product_name_id,
      company_id,
    } = singlePrivateLocalOrder;

    const BASE_URL =
      SERVER_URL + `/api/private-local/local-order-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_id,
        product_name_id,
        party_name,
        remarks,
        date,
        rate,
        gst_percent,
        received_date,
        total_order_qty,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      closeModal();
      resetFields();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const resetFields = () => {
    setSinglePrivateLocalOrder({
      rate: "",
      date: "",
      received_date: "",
      status: "",
      total_order_qty: "",
      gst_percent: "",
      remarks: "",
      party_name: "",
      product_name_id: "",
      company_id: "",
    });
    setSelectedCompanyId("");
    setRowId("");
    setSelectedProduct({
      product_id: "",
      product_name: "",
    });
    setApiHit(false);
    // setProductId("");
    // setProductId("");
  };

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="update"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Private Order
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {/* <div style={{ textAlign: "center" }} className="mb-4">
                <h6>
                  <i className="fa fa-info-circle"></i> Stock in Yard for
                  selected details :{" "}
                  <span style={{ fontSize: "18px" }}>
                    {closingStockInYard
                      ? closingStockInYard?.p_closing_stock
                      : 0}
                  </span>
                </h6>
              </div> */}
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form
                      className="form-sample"
                      onSubmit={handleAddDataSubmit}
                      //   ref={formRef}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="company">Company Name</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="company_id"
                              id="company"
                              onChange={handleChange}
                              value={singlePrivateLocalOrder.company_id}
                              required
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company.length > 0 &&
                                company?.map((item, id) => (
                                  <option
                                    value={item.id}
                                    key={id}
                                  >{`${item.company_name}, ${item.location}`}</option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="product">Product Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleChange}
                              value={JSON.stringify(selectedProduct)}
                              id="product"
                              required
                              name="product"
                              // disabled={!selectedCompanyId}
                            >
                              <option value="">Select Product Name</option>
                              {product &&
                                product.length &&
                                product.map((item, id) => {
                                  return (
                                    <option
                                      value={JSON.stringify({
                                        product_id: item.id,
                                        product_name: item.size,
                                      })}
                                      key={id}
                                    >{`${item.size}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="party">Party Name</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="party_name"
                              id="party"
                              onChange={handleChange}
                              value={singlePrivateLocalOrder.party_name}
                              required
                            >
                              <option value="">Select Party Name</option>
                              {party &&
                                party?.length > 0 &&
                                party?.map((item, id) => (
                                  <option
                                    value={item.party_name}
                                    key={id}
                                  >{`${item.party_name}`}</option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="date">Date</label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="date"
                                id="date"
                                placeholder="Date"
                                max={new Date().toISOString().split("T")[0]}
                                onChange={handleChange}
                                value={singlePrivateLocalOrder.date}
                                required
                                min={minDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="received">Received Date</label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="received_date"
                                id="received"
                                placeholder="Date"
                                max={new Date().toISOString().split("T")[0]}
                                onChange={handleChange}
                                value={singlePrivateLocalOrder.received_date}
                                required
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="total">Total Order Qty</label>
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                name="total_order_qty"
                                id="total"
                                placeholder="Total order qty"
                                onChange={handleChange}
                                value={singlePrivateLocalOrder.total_order_qty}
                                required
                                min="1"
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Rate">Rate</label>
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                name="rate"
                                id="Rate"
                                autoComplete="off"
                                placeholder="Enter rate"
                                onChange={handleChange}
                                value={singlePrivateLocalOrder.rate}
                                required
                                min="1"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="percent">GST %</label>
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                name="gst_percent"
                                id="percent"
                                autoComplete="off"
                                placeholder="Enter gst percent"
                                onChange={handleChange}
                                value={singlePrivateLocalOrder.gst_percent}
                                // required
                                min="1"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Remarks">Remarks</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="remarks"
                                id="Remarks"
                                autoComplete="off"
                                placeholder="Enter remarks"
                                onChange={handleChange}
                                value={singlePrivateLocalOrder.remarks}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* {singlePrivateLocalOrder?.order_details?.length > 0 &&
                        orderNumbers?.map((order, index) => {
                          const isInitialYardId =
                            order.yard_id &&
                            initialYardIds.includes(order.yard_id);
                          const isInitialCompanyId =
                            order.company_id &&
                            initialCompanyIds.includes(order.company_id);
                          const isInitialProductNameId =
                            order.product_name_id &&
                            initialProductNameIds.includes(
                              order.product_name_id
                            );
                          return (
                            <div key={index} className="row">
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label htmlFor="Company">Company Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.company_id}
                                    disabled={isInitialCompanyId}
                                    onChange={(e) =>
                                      handleCompanyChange(e, index)
                                    }
                                    id="Company"
                                  >
                                    <option value="">Select Company</option>
                                    {company &&
                                      company?.length > 0 &&
                                      company.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.company_name}, ${item.location}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label htmlFor="product">Product Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.product_name_id}
                                    onChange={(e) =>
                                      handleProductChange(e, index)
                                    }
                                    disabled={
                                      !selectCompanyId || isInitialProductNameId
                                    }
                                  >
                                    <option value="">Select Product</option>
                                    {product &&
                                      product[index]?.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.size}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label htmlFor="yard">Yard Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.yard_id}
                                    onChange={(e) => handleYardChange(e, index)}
                                    disabled={
                                      !selectCompanyId || isInitialYardId
                                    }
                                  >
                                    <option value="">Select yard</option>
                                    {yard &&
                                      yard[index]?.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.yard_name}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label htmlFor="qty">Order Quantity</label>
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={order.order_qty}
                                      onChange={(e) =>
                                        handleQtyChange(e, index)
                                      }
                                      placeholder="Order Quantity"
                                    />
                                    <span className="input-group-append ml-2">
                                      <div className="col-md-2">
                                        <button
                                          type="button"
                                          title="Remove"
                                          disabled={
                                            isInitialCompanyId ||
                                            isInitialProductNameId ||
                                            isInitialYardId
                                          }
                                          className="btn btn-outline-danger btn-rounded btn-icon"
                                          onClick={() =>
                                            removeOrderNumberRow(index)
                                          }
                                        >
                                          <span className="mdi mdi-close-thick"></span>
                                        </button>
                                      </div>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })} */}
                      {/* <span className="input-group-append ml-2">
                        <button
                          className="btn btn-primary mt-3"
                          type="button"
                          onClick={addOrderNumberRow}
                        >
                          Add More
                        </button>
                      </span> */}
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdatePrivateLocalOrderDetail;
